import fileExemple from './file-exemple'
import importFile from './import-file'
import auth from './auth.service'

export default {
  fileExemple,
  importFile,
  auth
}
